import React from 'react';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getDictionary } from '../../helpers/cart';

const NewCartDialog = (props) => {

    const title = getDictionary(props.type, props.id ? 'edit_title' : 'add_title');
    const confirmText = props.cart ? getDictionary(props.cart.type, 'new_confirm') : "";

    return (
        <Dialog
            open={props.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {confirmText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onConfirm(true, props.id)} color="primary" autoFocus>
                Sí
                </Button>
                <Button onClick={() => props.onConfirm(false, props.id)} color="primary">
                No
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default NewCartDialog;